export const DEFAULT_WORKSPACE_ID = 'common'
